module.exports = __webpack_public_path__ + "slide-2-ZXy.jpg";